import { IImageProps, Image } from 'native-base'
import React from 'react'

import { AbsoluteFullFill } from '../atoms/AbsoluteFullFill'
const placeholder =
  'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcS1Y9CB46yAjxwMTT6COSfEz6ALOKJiSSRqeQ&usqp=CAU'

export const BackgroundImage = (props: IImageProps = {}): JSX.Element => (
  <AbsoluteFullFill>
    <Image
      alt="background_image"
      borderRadius="xl"
      h="100%"
      resizeMode="cover"
      source={{
        uri: placeholder,
      }}
      w="100%"
      {...props}
    />
  </AbsoluteFullFill>
)
